/**
 * @classdesc Czech Language Pack
 * @desc This class will used to translate tokens into the Czech language.
 * @namespace Languages.Czech
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Czech
 */
export const dictionary = {
    'years'   : 'Roky',
    'months'  : 'Měsíce',
    'days'    : 'Dny',
    'hours'   : 'Hodiny',
    'minutes' : 'Minuty',
    'seconds' : 'Sekundy'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Czech
 */
export const aliases = ['cs', 'cs-cz', 'cz', 'cz-cs', 'czech'];
